<template>
    <div class="checkbox-styles">
        <input 
            type="checkbox" 
            class="checkbox"
            v-model="model"
            v-on:change="updateCheck"
        >
    </div>
</template>

<script setup>
    import { defineModel } from 'vue';
    const model = defineModel()

    function updateCheck() {
        model.isChecked = !model.isChecked
    }
</script>


<style scoped>
    .checkbox-styles {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
    }

    .checkbox {
        appearance: none;
        background-color: transparent;
        margin: 0;
        width: 20px;
        height: 20px;
        border: 2px solid #303030;
        border-radius: 3px;
        display: grid;
        place-content: center;
        user-select: none;
        cursor: pointer;
    }
    .checkbox::before {
        content: "";
        width: 10px;
        height: 10px;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #0A84FF;
    }
    .checkbox:hover {
        border-color: #0A84FF;
    }
    .checkbox:checked::before {
        transform: scale(1);
    }
    .checkbox:checked {
        border-color: #0A84FF;
    }



</style>
